import { Box, ButtonBase } from '@mui/material';
import { dashboardRouteConfig } from 'modules/dashboard';
import { Logo } from 'modules/layout/components/Logo';
import { Link } from 'react-router-dom';

const homePath = dashboardRouteConfig.main.generatePath();

const HIDE_FOOTER_LOGO = true;

export function FooterLogo(): JSX.Element {
  if (HIDE_FOOTER_LOGO) {
    return <Box sx={{ display: { xs: 'none', sm: 'flex' } }} />;
  }

  return (
    <ButtonBase
      sx={{ display: { xs: 'none', sm: 'flex' } }}
      to={homePath}
      component={Link}
    >
      <Logo style={{ height: 22 }} />
    </ButtonBase>
  );
}
